import { type PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next/pages';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import {
  ExpandableLabel as ExpandableLabelComponent,
  type ExpandableLabelProps,
} from '@/components/common/ExpandableLabel/ExpandableLabel';

export const ExpandableLabel = ({
  children,
  ...props
}: PropsWithChildren<Omit<ExpandableLabelProps, 'readLessLabel' | 'readMoreLabel'>>) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);

  return (
    <ExpandableLabelComponent
      {...props}
      readLessLabel={t('search.expose.propertyDetails.label.showLess')}
      readMoreLabel={t('search.expose.propertyDetails.label.showMore')}
    >
      {children}
    </ExpandableLabelComponent>
  );
};
